import { put, takeEvery } from "redux-saga/effects";
import { SYSTEM_INIT_SAGA, SYSTEM_INITIALIZED } from "@/Redux/System/SystemConstants";

function* systemInitSaga() {
    try {
        //const res = yield call(
        //    fetchQuery,
        //    relayGuestEnvironment(),
        //    graphql`
        //        query SystemSagasInitQuery {
        //        }
        //    `,
        //    {}
        //);

        yield put({
            type: SYSTEM_INITIALIZED,
        });
    } catch (e) {
        throw e;
    }
}

export default function* SystemSagas() {
    yield takeEvery(SYSTEM_INIT_SAGA, systemInitSaga);
}
